module.exports = __webpack_public_path__ + "a2314fc9/img/mention-icon.8b3452e6.svg";